import { NavLink } from "react-router-dom";
import {
    AccountCircle,
    Apartment,
    ArrowDropDown,
    ArrowDropUp,
    Article,
    Business,
    BusinessCenter,
    GridView,
    KeyboardArrowDown,
    KeyboardArrowUp,
    Settings,
    SolarPower,
    SurfingRounded,
    VerifiedUser,
    Leaderboard,
    Accessibility,
    Work,
    Store,
    Engineering,
    DesignServices,
    DocumentScanner,
} from "@mui/icons-material";
import { NavBarButton } from "../../Layouts/ButtonsControlled";
import { DropDown, DropDownContainer, NavLinksContainer } from "./NavBarStyle";
import { IconButton } from "@mui/material";
import { useState } from "react";
import DraftsIcon from "@mui/icons-material/Drafts";
import RightNavLinks from "./RightNavLinks";

const NavLinks = ({ active }) => {
    const [dropDown, setDropDown] = useState(false);
    return (
        <>
            <RightNavLinks active={active}></RightNavLinks>
            {/* <NavLinksContainer>
                {active && <h5>MANAGEMENT</h5>}
                <ul className={`"ul" ${active ? "" : "show"}`}>
                    <li>
                        <NavLink to="app">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<GridView />}
                                >
                                    Dashboard
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <GridView className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="users">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<AccountCircle />}
                                >
                                    Users
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <AccountCircle className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="panels">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<SolarPower />}
                                >
                                    panels
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <SolarPower className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="utility">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<Apartment />}
                                >
                                    Utility Providers
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <Apartment className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="leads">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<Leaderboard />}
                                >
                                    Leads
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <Leaderboard className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="installer">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<Accessibility />}
                                >
                                    Installer
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <Accessibility className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="business">
                            {active ? (
                                <NavBarButton fullWidth startIcon={<Work />}>
                                    Business
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <Work className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="vendors">
                            {active ? (
                                <NavBarButton fullWidth startIcon={<Store />}>
                                    Vendors
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <Store className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="contractors">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<Engineering />}
                                >
                                    Contractors
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <Engineering className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="designers">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<DesignServices />}
                                >
                                    Designers
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <DesignServices className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="eversign-documents">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<DocumentScanner />}
                                >
                                    Eversign Documents
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <DocumentScanner className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="mails">
                            {active ? (
                                <NavBarButton
                                    fullWidth
                                    startIcon={<DraftsIcon />}
                                >
                                    Mails
                                </NavBarButton>
                            ) : (
                                <IconButton>
                                    <DraftsIcon className="icon_menu" />
                                </IconButton>
                            )}
                        </NavLink>
                    </li>
                </ul>

                <!-- start a dropdown setting  -->
                {active ? (
                    <DropDownContainer>
                        <NavBarButton
                            onClick={() => setDropDown(!dropDown)}
                            fullWidth
                            startIcon={<Settings />}
                            endIcon={
                                !dropDown ? (
                                    <KeyboardArrowDown />
                                ) : (
                                    <KeyboardArrowUp />
                                )
                            }
                        >
                            <p>Settings</p>
                        </NavBarButton>
                        {dropDown && (
                            <DropDown className={active ? "" : "show"}>
                                <li>
                                    <NavLink to="uil">
                                        {active ? (
                                            <NavBarButton
                                                fullWidth
                                                startIcon={<AccountCircle />}
                                            >
                                                Utility Providers
                                            </NavBarButton>
                                        ) : (
                                            <IconButton>
                                                <AccountCircle className="icon_menu" />
                                            </IconButton>
                                        )}
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink to="uil">
                                        {active ? (
                                            <NavBarButton
                                                fullWidth
                                                startIcon={<Leaderboard />}
                                            >
                                                Leads
                                            </NavBarButton>
                                        ) : (
                                            <IconButton>
                                                <Leaderboard className="icon_menu" />
                                            </IconButton>
                                        )}
                                    </NavLink>
                                </li>
                            </DropDown>
                        )}
                    </DropDownContainer>
                ) : (
                    <IconButton>
                        <Settings className="icon_menu" />
                    </IconButton>
                )}
            </NavLinksContainer> */}
        </>
    );
};

export default NavLinks;
